module.exports = __webpack_public_path__ + "img/route.7449932c.svg";